(function($) {
  'use strict';

  // Chave do localStorage
  const WISHLIST_STORAGE_KEY = 'shopify_wishlist';
  
  // Inicialização
  $(document).ready(function() {
    initWishlistSystem();
    updateWishlistButtons();
  });

  /**
   * Inicializa o sistema de wishlist
   */
  function initWishlistSystem() {
    // Adicionar ao wishlist
    $(document).on('click', '.engoj_add_to_wishlist, .engoj_add_to_wishlist_pd', function(e) {
      e.preventDefault();
      const button = $(this);
      
      // Tentar obter product ID de várias formas
      let productId = button.data('product-id');
      
      // Se não encontrou no botão, tentar no container pai
      if (!productId) {
        productId = button.closest('[data-product-id]').data('product-id');
      }
      
      // Se ainda não encontrou, tentar buscar do contexto do produto
      if (!productId) {
        const productContainer = button.closest('.product-container, .product-item, .product-item-v1, .engoj_grid_parent');
        if (productContainer.length) {
          // Tentar buscar do link do produto
          const productLink = productContainer.find('a[href*="/products/"]').first();
          if (productLink.length) {
            const href = productLink.attr('href');
            // Tentar extrair handle e buscar ID via data attribute
            const handleMatch = href.match(/\/products\/([^\/\?]+)/);
            if (handleMatch) {
              // Tentar encontrar elemento com data-product-handle
              const handle = handleMatch[1];
              const productElement = $('[data-product-handle="' + handle + '"]');
              if (productElement.length) {
                productId = productElement.data('product-id');
              }
            }
          }
        }
      }
      
      // Última tentativa: buscar do elemento mais próximo com data-product-id
      if (!productId) {
        productId = button.closest('[data-product-id]').data('product-id');
      }
      
      if (!productId) {
        console.error('Product ID não encontrado. Verifique se o produto tem data-product-id.');
        console.log('Button:', button[0]);
        console.log('Container:', button.closest('.product-item-v1, .engoj_grid_parent')[0]);
        return;
      }

      toggleWishlist(productId, button);
    });

    // Remover do wishlist
    $(document).on('click', '.btn-remove-wishlist', function(e) {
      e.preventDefault();
      const button = $(this);
      const productId = button.data('product-id');
      
      if (productId) {
        removeFromWishlist(productId);
        button.closest('tr, .wishlist-item').fadeOut(300, function() {
          $(this).remove();
          updateWishlistCount();
        });
      }
    });
  }

  /**
   * Obtém a lista de wishlist do localStorage
   */
  function getWishlist() {
    try {
      const wishlist = localStorage.getItem(WISHLIST_STORAGE_KEY);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (e) {
      console.error('Erro ao ler wishlist do localStorage:', e);
      return [];
    }
  }

  /**
   * Salva a lista de wishlist no localStorage
   */
  function saveWishlist(wishlist) {
    try {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(wishlist));
      updateWishlistCount();
      // Disparar evento customizado para outros scripts
      $(document).trigger('wishlist:updated', [wishlist]);
    } catch (e) {
      console.error('Erro ao salvar wishlist no localStorage:', e);
    }
  }

  /**
   * Verifica se um produto está no wishlist
   */
  function isInWishlist(productId) {
    const wishlist = getWishlist();
    return wishlist.some(item => item.id === productId.toString());
  }

  /**
   * Adiciona produto ao wishlist
   */
  function addToWishlist(productId, productData) {
    const wishlist = getWishlist();
    
    // Verificar se já existe
    if (isInWishlist(productId)) {
      return false;
    }

    // Adicionar produto
    const product = {
      id: productId.toString(),
      title: productData?.title || '',
      handle: productData?.handle || '',
      url: productData?.url || `/products/${productData?.handle || ''}`,
      image: productData?.image || '',
      price: productData?.price || '',
      variantId: productData?.variantId || null,
      addedAt: new Date().toISOString()
    };

    wishlist.push(product);
    saveWishlist(wishlist);
    return true;
  }

  /**
   * Remove produto do wishlist
   */
  function removeFromWishlist(productId) {
    const wishlist = getWishlist();
    const filtered = wishlist.filter(item => item.id !== productId.toString());
    saveWishlist(filtered);
    return true;
  }

  /**
   * Alterna produto no wishlist (adiciona ou remove)
   */
  function toggleWishlist(productId, button) {
    const productData = getProductData(button);
    
    if (isInWishlist(productId)) {
      removeFromWishlist(productId);
      updateButtonState(button, false);
    } else {
      addToWishlist(productId, productData);
      updateButtonState(button, true);
    }
  }

  /**
   * Obtém dados do produto do DOM
   */
  function getProductData(button) {
    const productContainer = button.closest('.product-container, .product-item, .product-item-v1, [data-product-id], .add-wishlist').parent();
    
    // Buscar product ID
    let productId = button.data('product-id');
    if (!productId) {
      productId = productContainer.closest('[data-product-id]').data('product-id');
    }
    if (!productId) {
      productId = button.closest('[data-product-id]').data('product-id');
    }
    
    // Buscar título
    let title = button.data('product-title');
    if (!title) {
      title = productContainer.find('.product-title, .title-product, h3, h4, .title, a[href*="/products/"]').first().text().trim();
    }
    
    // Buscar handle
    let handle = button.data('product-handle');
    if (!handle) {
      const productLink = productContainer.find('a[href*="/products/"]').first();
      if (productLink.length) {
        const href = productLink.attr('href');
        handle = href.match(/\/products\/([^\/\?]+)/);
        handle = handle ? handle[1] : null;
      }
    }
    
    // Buscar URL
    let url = button.data('product-url');
    if (!url) {
      url = productContainer.find('a[href*="/products/"]').first().attr('href') || '';
    }
    
    // Buscar imagem
    let image = button.data('product-image');
    if (!image) {
      image = productContainer.find('img').first().attr('src') || '';
    }
    
    // Buscar preço
    let price = button.data('product-price');
    if (!price) {
      // Tentar buscar do elemento de preço
      const priceElement = productContainer.find('.price, .product-price, .money, .price-product, [class*="price"]').first();
      if (priceElement.length) {
        price = priceElement.text().trim();
        // Limpar formatação extra se necessário
        price = price.replace(/\s+/g, ' ').trim();
      }
    }
    
    // Se não encontrou preço, tentar buscar do link do produto via data attribute
    if (!price) {
      const productLink = productContainer.find('a[href*="/products/"]').first();
      if (productLink.length) {
        price = productLink.data('price') || '';
      }
    }
    
    return {
      id: productId ? productId.toString() : null,
      title: title || 'Produto',
      handle: handle || '',
      url: url || (handle ? '/products/' + handle : '#'),
      image: image || '',
      price: price || 'Consultar preço',
      variantId: button.data('variant-id') || null
    };
  }

  /**
   * Atualiza o estado visual do botão wishlist
   */
  function updateButtonState(button, isAdded) {
    if (isAdded) {
      button.addClass('added wish').removeClass('engoj_add_to_wishlist engoj_add_to_wishlist_pd loading');
      
      // Se for botão, converter para link
      if (button.is('button')) {
        const link = $('<a>', {
          href: '/pages/lista-de-desejos',
          class: button.attr('class')
        });
        link.html(button.html());
        button.replaceWith(link);
      }
    } else {
      button.removeClass('added wish loading');
    }
  }

  /**
   * Atualiza todos os botões de wishlist na página
   */
  function updateWishlistButtons() {
    const wishlist = getWishlist();
    const productIds = wishlist.map(item => item.id);

    $('[data-product-id]').each(function() {
      const button = $(this);
      const productId = button.data('product-id');
      
      if (productIds.includes(productId.toString())) {
        updateButtonState(button, true);
      } else {
        updateButtonState(button, false);
      }
    });
  }

  /**
   * Atualiza contador de wishlist (se existir)
   */
  function updateWishlistCount() {
    const wishlist = getWishlist();
    const count = wishlist.length;
    
    $('.wishlist-count, [data-wishlist-count]').text(count);
    
    // Atualizar badge se existir
    if (count > 0) {
      $('.wishlist-badge').show().text(count);
    } else {
      $('.wishlist-badge').hide();
    }
  }

  /**
   * Obtém todos os produtos do wishlist
   */
  function getAllWishlistProducts() {
    return getWishlist();
  }

  /**
   * Limpa todo o wishlist
   */
  function clearWishlist() {
    localStorage.removeItem(WISHLIST_STORAGE_KEY);
    updateWishlistCount();
    $(document).trigger('wishlist:cleared');
  }

  // Expor funções globalmente se necessário
  window.WishlistManager = {
    add: addToWishlist,
    remove: removeFromWishlist,
    toggle: toggleWishlist,
    isInWishlist: isInWishlist,
    getAll: getAllWishlistProducts,
    clear: clearWishlist,
    getCount: function() { return getWishlist().length; }
  };

  // Atualizar contador ao carregar
  updateWishlistCount();

})(jQuery);
